import script from "./SelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./SelectInput.vue?vue&type=style&index=0&id=3c104ab1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c104ab1"]])

export default __exports__